"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "casalvieri": {
    "purgatorio": [{
      "hkey": "b495a537",
      "slug": "casalvieri",
      "name": "Casalvieri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "67300dd0": [{
      "hkey": "b495a537",
      "slug": "casalvieri",
      "name": "Casalvieri",
      "primary": true,
      "skipSearch": false
    }],
    "roselli": [{
      "hkey": "b495a537",
      "slug": "casalvieri",
      "name": "Casalvieri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cfe8d072": [{
      "hkey": "b495a537",
      "slug": "casalvieri",
      "name": "Casalvieri",
      "primary": true,
      "skipSearch": false
    }],
    "valloni": [{
      "hkey": "b495a537",
      "slug": "casalvieri",
      "name": "Casalvieri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7672a052": [{
      "hkey": "b495a537",
      "slug": "casalvieri",
      "name": "Casalvieri",
      "primary": true,
      "skipSearch": false
    }],
    "canalara": [{
      "hkey": "b495a537",
      "slug": "casalvieri",
      "name": "Casalvieri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0b739ca3": [{
      "hkey": "b495a537",
      "slug": "casalvieri",
      "name": "Casalvieri",
      "primary": true,
      "skipSearch": false
    }],
    "colle-la-fossa": [{
      "hkey": "b495a537",
      "slug": "casalvieri",
      "name": "Casalvieri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "daf33ca2": [{
      "hkey": "b495a537",
      "slug": "casalvieri",
      "name": "Casalvieri",
      "primary": true,
      "skipSearch": false
    }],
    "fallena": [{
      "hkey": "b495a537",
      "slug": "casalvieri",
      "name": "Casalvieri",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bb226d06": [{
      "hkey": "b495a537",
      "slug": "casalvieri",
      "name": "Casalvieri",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;